import { MessageCircle } from "lucide-react";

export const waNumber = (phone) => {
  const d = String(phone).replace(/\D/g, "");
  return d.startsWith("0") ? `593${d.slice(1)}` : d;
};

export const WaButton = ({ phone, testid }) => (
  <a href={`https://wa.me/${waNumber(phone)}`} target="_blank" rel="noopener noreferrer"
    className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#25D366]/15 text-[#25D366] text-xs font-semibold hover:bg-[#25D366]/25 transition-colors"
    data-testid={testid}><MessageCircle size={12} /> WhatsApp</a>
);
